<template>
  <div class="sku-weeks-page">
    <div class="st-header">
      <div>
        <span class="header-eyebrow">Taller</span>
        <h2 class="header-title">Semanas de produccion</h2>
      </div>
    </div>

    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ articulos.length }}</span>
        <span class="kpi-foot">SKUs</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Mostrando</span>
        <span class="kpi-value">{{ articulosBusqueda.length }}</span>
        <span class="kpi-foot">resultados</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Sin asignar</span>
        <span class="kpi-value">{{ articulosSinAsignar }}</span>
        <span class="kpi-foot">pendientes</span>
      </div>
    </div>

    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado</h3>
        <div class="toolbar">
          <label class="filter-toggle">
            <input v-model="soloPendientes" type="checkbox">
            <span>Solo sin semanas</span>
          </label>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              v-model="buscar"
              type="text"
              class="search-box__input"
              placeholder="Buscar SKU o titulo..."
            />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="articulosBusqueda"
          :fields="columnasSku"
          class="mb-0"
          hover
          sort-icon-left
          responsive
          show-empty
          empty-text="Sin resultados"
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #cell(skuSingle)="data">
            <span class="cell-sku">{{ data.item.skuSingle }}</span>
          </template>

          <template #cell(productTitle)="data">
            <span class="cell-title">{{ data.item.productTitle || '--' }}</span>
          </template>

          <template #cell(semanasProduccion)="data">
            <div class="weeks-actions">
              <button
                v-for="week in quickWeeks"
                :key="`${data.item.skuSingle}-${week}`"
                class="btn-week"
                :class="{ 'btn-week--active': data.item.productionWeeks === week }"
                @click="guardarSemanas(data.item, week)"
              >
                {{ week }} semana<span v-if="week > 1">s</span>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ articulosBusqueda.length }} SKUs</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import { BTable } from 'bootstrap-vue'

export default {
  components: { BTable },
  data() {
    return {
      columnasSku: [
        { key: 'skuSingle', label: 'SKU', sortable: true },
        { key: 'productTitle', label: 'Titulo', sortable: true },
        { key: 'semanasProduccion', label: 'Semanas produccion', sortable: true },
      ],
      articulos: [],
      articulosBusqueda: [],
      buscar: '',
      quickWeeks: [1, 2, 3],
      soloPendientes: false,
    }
  },
  computed: {
    articulosSinAsignar() {
      return this.articulos.filter(item => item.productionWeeks === null || typeof item.productionWeeks === 'undefined').length
    },
  },
  methods: {
    aplicarFiltros() {
      const buscarLower = this.buscar.toLowerCase()

      this.articulosBusqueda = this.articulos.filter(item => {
        const sku = item.skuSingle ? item.skuSingle.toLowerCase() : ''
        const title = item.productTitle ? item.productTitle.toLowerCase() : ''
        const coincideBusqueda = sku.includes(buscarLower) || title.includes(buscarLower)
        const pendiente = item.productionWeeks === null || typeof item.productionWeeks === 'undefined'

        if (!coincideBusqueda) return false
        if (this.soloPendientes && !pendiente) return false

        return true
      })
    },
    loadItems() {
      axios.post('/uso', { seccion: 'skuSemanasProduccion' })
      axios.get('/sku/production-weeks').then(r => r.data).then(res => {
        this.articulos = res
        this.aplicarFiltros()
      })
    },
    guardarSemanas(data, weeks) {
      axios.post('/sku/production-weeks', {
        sku: data.skuSingle,
        weeks,
      }).then(r => r.data).then(() => {
        data.productionWeeks = weeks
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 1800,
          timerProgressBar: true,
          showConfirmButton: false,
          icon: 'success',
          title: `${data.skuSingle}: ${weeks} semana${weeks > 1 ? 's' : ''}`,
        })
        this.aplicarFiltros()
      })
    },
  },
  mounted() {
    this.loadItems()
  },
  watch: {
    buscar() {
      this.aplicarFiltros()
    },
    soloPendientes() {
      this.aplicarFiltros()
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$success: #10B981;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);

.sku-weeks-page { max-width: 1440px; margin: 0 auto; padding: 0 8px; }

.st-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: $primary; margin-bottom: 2px; }
.header-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 700; color: $text; margin: 0; }

.kpi-strip { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 20px; max-width: 620px; }
.kpi-card { background: $card-bg; border: 1px solid $border; border-radius: $radius-sm; padding: 16px 18px; display: flex; flex-direction: column; box-shadow: $shadow; }
.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: 'tnum'; margin: 4px 0 2px; }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $text-muted; }

.list-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header { display: flex; justify-content: space-between; align-items: center; padding: 18px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0; }
  &__footer { padding: 12px 22px; border-top: 1px solid $border; }
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
}

.filter-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: $text;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.search-box {
  position: relative;
  width: 260px;

  &__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: $text-muted; font-size: 12px; }
  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

.table-wrapper { padding: 0; }

// Los ::v-deep van bajo .sku-weeks-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.sku-weeks-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 10px 16px;
  background: transparent;
}

.sku-weeks-page ::v-deep .table-row td {
  padding: 8px 16px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
}

.sku-weeks-page ::v-deep .table-row:hover td { background: $bg; }

.cell-sku {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  color: $primary;
}

.cell-title {
  color: $text;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.weeks-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.btn-week {
  border: 1px solid $border;
  border-radius: 8px;
  background: white;
  color: $text;
  cursor: pointer;
  padding: 8px 12px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.15s;
}

.btn-week:hover {
  border-color: $primary;
  color: $primary;
}

.btn-week--active {
  background: rgba($success, 0.12);
  border-color: rgba($success, 0.45);
  color: darken($success, 8%);
}

.footer-count { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text-muted; }

@media (max-width: 768px) {
  .list-card__header { flex-direction: column; gap: 10px; align-items: flex-start; }
  .toolbar { width: 100%; flex-direction: column; align-items: flex-start; }
  .search-box { width: 100%; }
  .weeks-actions { min-width: 220px; }
}
</style>

<style lang="scss">
.dark-layout {
  .sku-weeks-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .search-box__input { border-color: #334155; color: #E2E8F0; &::placeholder { color: #475569; } &:focus { border-color: #3B82F6; } }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255, 255, 255, 0.03); }

    .cell-sku { color: #60A5FA; }
    .cell-title { color: #E2E8F0; }
    .btn-week { border-color: #334155; color: #E2E8F0; background: #0F172A; }
    .btn-week:hover { border-color: #3B82F6; color: #60A5FA; }
    .btn-week--active { background: rgba(#10B981, 0.18); border-color: rgba(#10B981, 0.5); color: #6EE7B7; }
  }
}
</style>
